<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-col class="container text-right"> </b-col>

      <b-card class="mt-2 col-12">
        <b-col class="container text-right">
          <b-button variant="info" class="mb-2 mr-sm-2" @click="onBtnAddComplaintGroupClicked">
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>จัดกลุ่มร้องทุกข์</span>
          </b-button>
        </b-col>
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title"
            :title="tab.title"
            lazy
            @click.prevent="setActiveTabName(tab.mode, tab.header)"
          >
            <b-col cols="12">
              <SearchFilter
                ref="searchFilter"
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-card v-for="tab in activeTab" :id="tab" :key="tab">
        <commonTable
          ref="tableCommon"
          :routeName="$route.name"
          :tableHeader="tableHeader"
          :searchMode="tab"
          @handleGroup="getManage"
          @handleOverlay="setOverlay"
        >
          <b-tabs
            v-if="tabs.find((value) => value.mode === tab).subTabs.length > 0"
          >
            <b-tab
              v-for="subTab in tabs.find((value) => value.mode === tab).subTabs"
              :key="subTab.title"
              :title="subTab.title"
              lazy
              @click.prevent="
                setActiveTabSubName(
                  tabs.find((value) => value.mode === tab),
                  subTab.mode
                )
              "
            >
            </b-tab>
          </b-tabs>
        </commonTable>
      </b-card>
    </b-overlay>

    <ModalNotification
      ref="ModalNotification"
      :complaints="notificationComplaints"
    />

    <ModalComplaintGroup
      ref="ModalComplaintGroup"
      modeGrp="LawOfficer"
      :isInGroup="false"
      :complaintGroupId="null"
      :complaintGroupCode="null"
      :complaintGroupIssue="null"
    />

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import commonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
import commonTableHeader from "@/views/Complaint/components/vueGoodTable/commonTableHeader.js";
import SearchFilter from "@/views/Complaint/components/vueGoodTable/SearchFilter.vue";
import ModalNotification from "./components/ModalNotification.vue";

import commonTable2 from "../../table/vue-good-table/commonTableModal.vue";
import * as officerStore from "@/store/api/officer/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import commonTableGroupHeader from "@/views/Complaint/components/vueGoodTable/commonTableGroupHeader.js";
import ModalComplaintGroup from "@/views/Complaint/components/ComplaintGroup/components/ModalComplaintGroup.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    commonTable2,
    SearchFilter,
    ModalNotification,
    BOverlay,
    ModalComplaintGroup,
  },
  data() {
    return {
      tabs: [
        {
          title: "รายการเรื่องร้องทุกข์",
          mode: "LawOfficer",
          header: commonTableHeader,
          activeTab: ["All"],
          subTabs: [
            { title: "แสดงทั้งหมด", mode: "All" },
            { title: "รอเอกสารเพิ่มเติม", mode: "WaitDoc" },
            { title: "แบบฟอร์มรอดำเนินการ", mode: "WaitDocApprove" },
            { title: "ผู้ร้องยุติเรื่อง", mode: "Cancel" },
          ],
        },
        {
          title: "การดำเนินการแบบเป็นกลุ่ม",
          mode: "UserGroup",
          header: commonTableGroupHeader,
          activeTab: [],
          subTabs: [
            { title: "ดำเนินการ", mode: "All" },
            { title: "ประวัติ", mode: "LawOfficerGroupHistory" },
          ],
        },
        {
          title: "ประวัติดำเนินการ",
          mode: "UserHistory",
          header: commonTableHeader,
          activeTab: [],
          subTabs: [],
        },
      ],
      activeTab: ["LawOfficer"],
      tableHeader: commonTableHeader,
      modalName: "my-modal",
      notificationComplaints: [],
      showOverlay: false,
    };
  },
  created() {
    //this.getComplaintNotification();
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    getComplaintNotification() {
      const _this = this;
      officerStore
        .getComplaintForNoti(userData.departmentId(), userData.userId())
        .then((response) => {
          console.log("data", response.data.data);
          if (response.data.data.totalresult > 0) {
            // show data
            _this.notificationComplaints = response.data.data.listForNewcase;

            _this.$refs.ModalNotification.$refs["modal-notification"].show();
          }
          //_this.$refs.ModalNotification.$refs["modal-notification"].show();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    setActiveTabName(name, header) {
      this.activeTab = [];
      this.activeTab.push(name);
      this.tableHeader = header;
    },
    setActiveTabSubName(tab, mode) {
      tab.activeTab = [];
      tab.activeTab.push(mode);
      this.$refs.searchFilter[0].onSearchBtnClicked();
    },
    getActiveTabSubName() {
      try {
        const _this = this;
        const activeTab = _this.tabs.find(
          (value) => value.mode === _this.activeTab[0]
        );
        if (activeTab.activeTab !== null && activeTab.activeTab !== undefined) {
          if (activeTab.activeTab.length > 0) {
            return activeTab.activeTab[0];
          }
        }

        return null;
      } catch (ex) {
        console.log("getActiveTabSubName ex", ex);
        return null;
      }
    },
    showCancelTab() {
      if (this.activeTab !== undefined) {
        if (this.activeTab === "List") {
          if (this.tab.activeTab[0] !== undefined) {
            if (this.tab.activeTab.length > 0) {
              if (this.tab.activeTab[0] === "Cancel") {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    getManage(id, isGroup) {
      if (this.activeTab[0] == "UserHistory") {
        if (isGroup === true) {
          this.getManageGroup(id);
        } else {
          const routeData = this.$router.resolve({
            name: "ComplaintHistoryDetail",
            query: { id },
          });
          window.open(routeData.href, "_blank");
        }

      } else if (this.activeTab[0] == "UserGroup") {
        this.getManageGroup(id);

      } else {
        if (isGroup === true) {
          this.getManageGroup(id);
        } else {
          const routeData = this.$router.resolve({
            name: "LawOfficerManage",
            query: { id },
          });
          window.open(routeData.href, "_blank");
        }
      }
    },
    getManageGroup(id) {
      const routeData = this.$router.resolve({
        name: "LawOfficerGroupManage",
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
    onBtnClosePopup() {
      if (this.$modals.isActive(this.modalName) === true)
        this.$modals.hide(this.modalName);
    },
    onBtnReceive() {
      if (this.$modals.isActive(this.modalName) === true)
        this.$modals.hide(this.modalName);
    },
    searchFilterSubmit(params) {
      params.departmentId = userData.departmentId();
      params.userActive = this.$route.query.id == null ? userData.userId() : this.$route.query.id
      
      // false : เรื่องที่ยังไม่ได้เอาเข้ากลุ่ม / true : เรื่องที่เอาเข้ากลุ่มแล้ว
      params.isInGroup = false;
      // เก็บชื่อ Tab ตามการที่กด
      params.tabName = this.getActiveTabSubName();
      // Tabs ย่อยของ ดำเนินการแบบเป็นกลุ่ม => ดำเนินการ [All]  / ประวัติ [GroupHistory]
      params.closeJob = params.tabName === 'OfficerGroupHistory' ? true : false;

      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    onBtnAddComplaintGroupClicked() {
      this.$refs.ModalComplaintGroup.$refs["modal-add-complaint-group"].show();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
